module.exports = __webpack_public_path__ + "static/media/grass.5cc318d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/alset-reactgame-test/games/gemCollector/code/assets/grass.jpg
// module id = 407
// module chunks = 0